<template>
  <div>
    <el-dialog
      :width="dialogWidth"
      :visible.sync="regions.length > 0"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :append-to-body="true"
      :before-close="closePopUp"
    >
      <div slot="title">
        <div class="el-dialog__title">
          {{ $t('Gamification_GameRegionSelectDialog_Title') }}
        </div>
        <div class="sub-title">
          {{ $t('Gamification_GameRegionSelectDialog_SubTitle') }}
        </div>
      </div>
      <div class="items-container">
        <div
          v-for="region in filteredRegions"
          :key="region.id"
          class="item-container"
        >
          <div
            class="item"
            :class="{
              'active-class': selectedRegion && selectedRegion.id === region.id
            }"
            @click="selectedRegion = region"
          >
            <icon class="icon" :glyph="region.continent" size="170" />
            <h3>{{ $t(RegionNameLabel[region.continent]) }}</h3>
            <p class="region-name">{{ region.name }}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="!selectedRegion"
          type="primary"
          icon="el-icon-check"
          @click="goToDashboard"
        >
          {{ $t('Gamification_GameRegionSelectDialog_SelectRegion') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { projectRoute } from '@/core/helpers'
import { RegionNameLabel } from '@/modules/gamification/enum/RegionNameEnum'

export default {
  name: 'GameRegionSelectDialog',

  props: {
    game: {
      type: Object,
      required: true
    },

    regions: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedRegion: null,
      activeRegion: null,
      RegionNameLabel,
      activeGame: {},
      activeRegions: []
    }
  },
  mounted() {
    this.initializeActiveRegions()
  },

  computed: {
    dialogWidth() {
      let width = 912

      const length = this.activeRegions.length
      if (length === 1 || length === 2 || length === 4) {
        width = 632
      }

      if (length === 7 || length === 8) {
        width = 1200
      }

      if (length >= 9) {
        width = 1550
      }

      return `${width}px`
    },
    filteredRegions() {
      return this.regions.filter(region =>
        this.activeRegions.includes(region.id)
      )
    }
  },

  methods: {
    closePopUp() {
      this.$emit('close')
    },
    goToDashboard() {
      if (!this.game.xp_backoffice_ui) {
        this.$router.push(
          projectRoute({
            name: 'GamesHubDashboard',
            query: {
              id: this.selectedRegion.game_id,
              domain: this.selectedRegion.dashboard_domain
            }
          })
        )
        return
      }
      this.$router.push(
        projectRoute({
          name: 'GameCampaignsList',
          params: { id: this.selectedRegion.game_id }
        })
      )
    },
    initializeActiveRegions() {
      this.activeGame = this.$store.getters.activeGames.find(
        game => game.game_id === this.game.id
      )
      if (this.activeGame && this.activeGame.regions) {
        this.activeRegions = this.activeGame.regions
      } else {
        this.activeGame = {}
        this.activeRegions = []
      }
    }
  }
}
</script>

<style scoped>
>>> .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>> .el-dialog__body {
  overflow: auto;
}

>>> .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 20px;
}

.active-class {
  background-color: #f2f5f9;
  border: 3px solid #1d87c8;
  border-radius: 4px;
  box-sizing: border-box;
  margin: -1px;
  width: 256px !important;
  height: 252px !important;
}

.items-container {
  padding: 0 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.item-container {
  border: 1px solid #a7acba;
  border-radius: 4px;
  box-sizing: border-box;
  transition: all 0.5s;
}

.item-container:hover {
  box-shadow: rgba(67, 90, 111, 0.3) 0 0 1px,
    rgba(67, 90, 111, 0.47) 0 8px 10px -4px;
  transform: translateY(-2px);
  cursor: pointer;
}

.item {
  width: 254px;
  height: 250px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.icon {
  color: #1d87c8;
  margin-bottom: 10px;
}

.sub-title {
  color: #606266;
  font-size: 14px;
  padding-top: 5px;
}

.region-name {
  overflow: hidden;
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

@media screen and (max-height: 850px) {
  >>> .el-dialog__body {
    max-height: 450px;
  }
}

@media screen and (max-height: 650px) {
  >>> .el-dialog__body {
    max-height: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-dashboard/GameRegionSelectDialog.vue